import API from "shared/services/Api";
import { INameProvider, IProvidersType } from "shared/types";

export const getProvidersType = async (
  state: string,
  insurance: number,
  city: string,
  neighborhood: string,
  region?: string
): Promise<IProvidersType> =>
  API.get(
    `providers/type?${state && `state=${state}&`}insurance=${insurance}${
      city && `&city=${city}`
    }&${region && `region=${region}&`}${
      neighborhood && `neighborhood=${neighborhood}`
    }`
  );

export const getNameProvider = async (
  state: string,
  insurance: number,
  city: string,
  neigh: string,
  specialty: string,
  typeProvider: string,
  region?: string
): Promise<INameProvider> =>
  API.get(
    `providers?${state && `state=${state}&`}insurance=${insurance}${
      city && `&city=${city}`
    }${region && `&region=${region}`}${neigh && `&neighborhood=${neigh}`}${
      specialty && `&specialty=${specialty}`
    }${typeProvider && `&typeProvider=${typeProvider}`}`
  );
